/**
 * Arbeitsseiten mit Scanfläche/Warenkorb (Annahme, Kasse, Rückgabe, Prüfen, Vorab-Erfassung): Dort entfallen die mobile Tableiste
 * und die breite Hauptnavigation, stattdessen gibt es eine schlanke Kopfzeile (Plan Nr. 18).
 */
export const WORK_PAGE =
  /^\/basare\/[^/]+\/(kasse|annahme|rueckgabe|pruefen|laufzettel|einlass)\/?$/;

/**
 * Kassen-Modus: Auf der Kasse entfallen Kopfzeile, Hauptnavigation, Tableiste, Basar-Leiste und Fußzeile. Die Seite
 * bringt eine eigene kompakte Kopfzeile mit (Name, Sync-Stand, Menü) und füllt die ganze Bildschirmhöhe.
 */
export const CASH_PAGE = /^\/(basare\/[^/]+\/kasse|kasse-geraet\/[^/]+)\/?$/;

/** Kopplung per QR (Scan-Seite und Kopplungsseite): schlanke Kopfzeile ohne Hauptnavigation, auch für Geräte ohne Konto. */
export const PAIR_PAGE = /^\/kasse-(scannen|koppeln)\/?$/;
